import { render, staticRenderFns } from "./ShippingFapiao.vue?vue&type=template&id=5daff32b&scoped=true"
import script from "./ShippingFapiao.vue?vue&type=script&lang=js"
export * from "./ShippingFapiao.vue?vue&type=script&lang=js"
import style0 from "./ShippingFapiao.vue?vue&type=style&index=0&id=5daff32b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daff32b",
  null
  
)

export default component.exports